export enum TrendChanges {
  UP = 'up',
  DOWN = 'down',
  FLAT = 'flat',
}
